<!-- src/components/TestimonialRotator.vue -->
<template>
  <section class="testimonial-wrap">
    <v-container class="testimonial-inner">
      <div class="testimonial-row">
        <!-- Quote image -->
        <div class="quote-icon">
          <img :src="quoteImg" alt="Quote marks" />
        </div>

        <!-- Text + author -->
        <div class="quote-content">
          <transition name="fade" mode="out-in">
            <div :key="activeIndex">
              <p class="quote-text">
                {{ current.text }}
              </p>
              <p class="quote-author">
                {{ current.author }}
                <span v-if="current.location">, {{ current.location }}</span>
              </p>
            </div>
          </transition>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'TestimonialRotator',
  props: {
    testimonials: {
      type: Array,
      required: true
    },
    intervalMs: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      quoteImg: new URL('@/assets/imgs/quote-marks.png', import.meta.url).href
    };
  },
  computed: {
    current() {
      return this.testimonials[this.activeIndex] || {};
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeUnmount() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.stopTimer();
      if (!this.testimonials || this.testimonials.length <= 1) return;

      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.testimonials.length;
      }, this.intervalMs);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goTo(i) {
      this.activeIndex = i;
      this.startTimer();
    }
  }
};
</script>

<style scoped>
.testimonial-wrap {
  background-color: #ffffff;
  padding-block: 3rem;
}

.testimonial-inner {
  max-width: 1100px;
  min-height: 200px; /* ensures consistent height for all quotes */
}

/* Layout */
.testimonial-row {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}

/* Quote image */
.quote-icon img {
  display: block;
  width: 42px;
  height: auto;
  flex-shrink: 0;
}

/* Text area */
.quote-content {
  flex: 1;
  position: relative;
  min-height: 200px; /* reserve space for the tallest quote */
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

/* Stack all quote items in same spot for fade transition */
.quote-content > div {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Text styling */
.quote-text {
  font-size: 1.4rem;
  font-weight: normal;
  line-height: 1.7;
  color: #333333;
  font-style: italic;
  margin-bottom: 1.5rem;
}

.quote-author {
  font-size: 0.95rem;
  color: #555555;
}

/* Fade animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Mobile */
@media (max-width: 600px) {
  .testimonial-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .quote-icon img {
    width: 32px;
  }
}

</style>
